import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  DeprecationBanner,
  React
};